import * as React from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  Stack,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";

import img1 from "../assets/img/sudhanshu image.jpg";
import img2 from "../assets/img/dr sid pic.jpg";
import img3 from '../assets/dheeraj-Lenovo.jpeg';
import img4 from '../assets/RAvi.png';
import img5 from '../assets/monu.png'
const teamMembers = [
  { name: "Sudhanshu Sharma", role: "FOUNDING DIRECTOR & CTO ", img: img1 },
  { name: "Dr. Siddharth Sharma", role: "FOUNDING DIRECTOR & CEO", img: img2 },
  {
    name: "Dheeraj Mishra",
    role: "Software Developer",
    img: img3,
  },
  {
    name: "Ravi kumar ",
    role: "Embedded Engineer",
    img: img4,
  },
  // {
  //   name: "Monu Mourya ",
  //   role: "Embedded Engineer",
  //   img: img5,
  // },
 
];

export default function TeamSection() {
  const theme = useTheme();

  const handleNavigateTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: "#f7f9fc" }}>
      <Container>
        {/* Heading */}
        <Stack spacing={1} textAlign="center">
          <Typography variant="h4" sx={{ fontWeight: 900 }}>
            Meet Our Team
          </Typography>
          <Typography color="text.secondary">
            A focused team delivering reliable MedTech solutions
          </Typography>
        </Stack>

        {/* Team Grid */}
        <Grid container spacing={3} sx={{ mt: 5 }} justifyContent="center">
          {teamMembers.map((member, i) => (
            <Grid
              item
              key={i}
              xs={12}
              sm={6}
              md={4}
              sx={{ display: "flex" }}
            >
              <Link
                to="/founders"
                onClick={handleNavigateTop}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  width: "100%",
                }}
              >
                <Card
                  sx={{
                    flex: 1,
                    textAlign: "center",
                    p: 3,
                    borderRadius: 4,
                    border: `1px solid ${alpha(
                      theme.palette.divider,
                      0.9
                    )}`,
                    transition: "all .25s ease",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow: "0 20px 50px rgba(0,0,0,.12)",
                    },
                  }}
                >
                  <Avatar
                    src={member.img}
                    alt={member.name}
                    sx={{
                      width: 96,
                      height: 96,
                      mx: "auto",
                      mb: 2,
                    }}
                  />

                  <CardContent sx={{ p: 0 }}>
                    <Typography fontWeight={800}>
                      {member.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {member.role}
                    </Typography>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
